import {Component, Input, OnInit} from '@angular/core';
import {BookingDTO} from '../../services/api/api';

@Component({
  selector: 'sb-comp-booking-status',
  templateUrl: './sb-booking-status.component.html',
  styleUrls: ['./sb-booking-status.component.scss'],
  standalone: false,
})
export class SbBookingStatusComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  _booking: BookingDTO;

  @Input() set booking(val: BookingDTO) {
    this._booking = val;
  }

  get booking(): BookingDTO {
    return this._booking;
  }

  constructor() {}

  ngOnInit(): void {}
}
